import {
    CLOSE_COUNTRY_FILTER,
    OPEN_COUNTRY_FILTER,
} from "../../components/filters-bar/country-filter/countryFilterActionTypes";
import {
    CLOSE_DURATION_FILTER,
    OPEN_DURATION_FILTER,
} from "../../components/duration-selector/durationFilterActionTypes";

export function WebsiteAnalysisFilters(state = { durationFilter: false, countryFilter: false }, action: FixmeType) {
    switch (action.type) {
        case OPEN_DURATION_FILTER: {
            return {
                ...state,
                durationFilter: true,
                periodOverPeriodCompareType: action.periodOverPeriodCompareType,
            };
        }
        case CLOSE_DURATION_FILTER: {
            return { ...state, durationFilter: false };
        }
        case OPEN_COUNTRY_FILTER: {
            return { ...state, countryFilter: true };
        }
        case CLOSE_COUNTRY_FILTER: {
            return { ...state, countryFilter: false };
        }
        default:
            return state;
    }
}
